import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Alert, Button, Typography } from '@mui/material';
import LoginLayout from './LoginLayout';

// The page a confirmation link opens.
//
// It is read on a phone, in a mail client, by somebody who has never seen this product before, so it
// does one thing and says plainly whether it worked. It is also the one page here that runs with no
// session at all - the token in the address is the whole of its authority, and it is spent on use.
const VerifyPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState({ status: 'working' });

  useEffect(() => {
    let cancelled = false;
    fetch(`/api/verify/${encodeURIComponent(token)}`, { method: 'POST', headers: { 'Content-Type': 'application/json', Origin: window.location.origin } })
      .then(async (response) => {
        const body = await response.json().catch(() => ({}));
        if (cancelled) return;
        if (response.ok) setState({ status: 'done', email: body.email, name: body.name });
        else setState({ status: 'failed', message: body.message || 'This confirmation link is not valid.' });
      })
      .catch(() => { if (!cancelled) setState({ status: 'failed', message: 'The server could not be reached. Try the link again in a moment.' }); });
    return () => { cancelled = true; };
  }, [token]);

  return (
    <LoginLayout>
      <Typography variant="h6" sx={{ mb: 1 }}>Confirming your address</Typography>
      {state.status === 'working' && <Typography color="text.secondary">One moment…</Typography>}
      {state.status === 'done' && (
        <>
          <Alert severity="success" sx={{ mb: 2 }}>{`${state.email} is confirmed. Reports and alerts sent to this address will reach you.`}</Alert>
          <Button variant="contained" onClick={() => navigate('/login')}>Sign in</Button>
        </>
      )}
      {state.status === 'failed' && (
        <>
          <Alert severity="error" sx={{ mb: 2 }}>{state.message}</Alert>
          <Button onClick={() => navigate('/login')}>Go to sign in</Button>
        </>
      )}
    </LoginLayout>
  );
};

export default VerifyPage;
